import {RowItem} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/RowItem";
import {TableControl} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/TableControl";
import {
    ColumnItemOptions,
    RowItemOptions,
    TableItemOptions
} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/TableControl.Options";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as React from "react";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faArrowsAlt} from "@fortawesome/free-solid-svg-icons/faArrowsAlt";
import {ColumnItem} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/ColumnItem";
import {ToastService} from "shared/utilities/services/ToastService";
import {TableMouseManager} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/TableMouseManager";
let ReactDOM:any=require('react-dom');


library.add(faArrowsAlt);
export class TableItem {
    public ContainerElement:HTMLElement;
    public Table:HTMLTableSectionElement;
    public Options:TableItemOptions;
    public RowItems:RowItem[];
    public SelectedColumns:ColumnItem[];


    constructor(public TableControl:TableControl) {
        this.SelectedColumns=[];
        this.Options=this.TableControl.Options.TableItem;


    }


    public Generate(containerElement: HTMLElement) {
        this.RowItems=[];
        this.ContainerElement=containerElement;
        this.ContainerElement.innerHTML='';

        this.Table=document.createElement('table') as any;
        this.Table.addEventListener('mousedown',(e)=>this.OnMouseDown(e));
        this.Table.classList.add('tablefield');
        this.ContainerElement.appendChild(this.Table);

        let tbody=document.createElement('tbody');
        this.Table.appendChild(tbody);
        this.Table=tbody;

        let move=document.createElement('span');
        move.className='movehandler';
        move.title='Move';
        move.addEventListener('mousedown',()=>this.TableControl.DragManager.lastResizeDirection=null);
        containerElement.appendChild(move);

        ReactDOM.render(<FontAwesomeIcon icon={'arrows-alt'}/>,move);



        this.CreateRows();
    }



    public SelectColumn(column:ColumnItem,deselectPreviousColumns:boolean=true)
    {

        if(deselectPreviousColumns&&this.SelectedColumns.length>0)
        {
            for(let column of this.SelectedColumns)
                column.Column.classList.remove('selected');
            this.SelectedColumns=[];
        }

        if(column!=null)
        {
            if(this.SelectedColumns.indexOf(column)>=0)
                return;
            this.SelectedColumns.push(column);
            if(this.SelectedColumns.length==1)
                column.Select();
            column.Highlight();
        }


    }

    public DeleteRow(row:RowItem)
    {
        if(this.RowItems.length==1) {
            ToastService.SendErrorMessage('The table should have at least one row');
            return;
        }
        row.Remove();
        let indexOfRow=this.RowItems.indexOf(row);

        if(indexOfRow>=0) {
            this.RowItems.splice(indexOfRow, 1);
            this.Options.Rows.splice(indexOfRow,1);
        }
    }

    public DeleteColumn(column:ColumnItem)
    {
        if(column.RowItem.ColumnItems.length==1)
        {
            ToastService.SendErrorMessage('The table should have at least one column');
            return;
        }

        let indexOfColumn=column.RowItem.ColumnItems.indexOf(column);

        if(indexOfColumn>=0)
            for(let row of this.RowItems)
            {
                row.RemoveColumnAtIndex(indexOfColumn);
            }


        let totalWidthToReassign= column.Options.Width;
        let additionalWidthForEachColumn=Math.floor(column.Options.Width/this.Options.Rows[0].Columns.length);
        let additionalWidthForLastRow=totalWidthToReassign-(additionalWidthForEachColumn*this.Options.Rows[0].Columns.length);
        for(let row of this.RowItems)
            for(let column of row.ColumnItems)
            {
                if(column.IsLastColumn)
                    column.SetWidth(column.Options.Width+additionalWidthForEachColumn+additionalWidthForLastRow);
                else
                    column.SetWidth(column.Options.Width+additionalWidthForEachColumn);
            }

    }

    private CreateRows() {
        for(let row of this.Options.Rows)
        {
            let currentRow=new RowItem(this,row);
            this.RowItems.push(currentRow);
            currentRow.Generate();
        }
    }




    private OnMouseDown(e: MouseEvent) {
        this.TableControl.Select();
        if(this.TableControl.DragManager.lastResizeDirection==null)
        {
            e.stopPropagation();
        }
    }

    DeselectColumn(column: ColumnItem) {
        if(this.SelectedColumns.indexOf(column)>=0)
        {
            this.SelectedColumns.splice(this.SelectedColumns.indexOf(column),1);
            column.Column.classList.remove('selected')
        }
    }

    public CreateRow(relativeTo:RowItem,position:'before'|'after')
    {
        let index=this.RowItems.indexOf(relativeTo);
        if(index<0)
            index=this.RowItems.length-1;

        if(position=='after')
            index++;


        let newRowItemOptions=new RowItemOptions().Merge();
        for(let i=0;i<this.RowItems[0].ColumnItems.length;i++)
        {
            newRowItemOptions.Columns.push(new ColumnItemOptions().Merge({Width:this.RowItems[0].ColumnItems[i].Options.Width}));
        }

        let newRow=new RowItem(this,newRowItemOptions);

        this.Options.Rows.splice(index,0,newRowItemOptions);
        this.RowItems.splice(index,0,newRow);


        let row=this.Table.insertRow(index);
        newRow.Generate(row);









    }

    public CreateColumn(relativeTo:ColumnItem,position:'before'|'after')
    {
        let index=relativeTo.RowItem.ColumnItems.indexOf(relativeTo);

        if(index<0)
        {
            index=relativeTo.RowItem.ColumnItems.length-1;

        }

        if(position=='after')
            index++;



        let width=this.PrepareTableForNewColumn();
        for(let row of this.RowItems)
        {
            let newColumnOptions=new ColumnItemOptions().Merge({Width:width});
            row.Options.Columns.splice(index,0,newColumnOptions);

            let newColumnItem=new ColumnItem(row,newColumnOptions);
            row.ColumnItems.splice(index,0,newColumnItem);
            let column=row.Row.insertCell(index);
            newColumnItem.Generate(column);


        }

        let newRowItemOptions=new RowItemOptions().Merge();
        for(let i=0;i<this.RowItems[0].ColumnItems.length;i++)
        {
            newRowItemOptions.Columns.push(new ColumnItemOptions().Merge());
        }

        let newRow=new RowItem(this,newRowItemOptions);

        this.Options.Rows.splice(index,0,newRowItemOptions);
        this.RowItems.splice(index,0,newRow);


        let row=this.Table.insertRow(index);
        newRow.Generate(row);
    }

    private PrepareTableForNewColumn() {
        let widthOfNewColumn=0;
        let newColumnCount=this.RowItems[0].ColumnItems.length+1;
        for(let column of this.RowItems[0].ColumnItems)
        {
            let widthToSustract=Math.floor(column.Options.Width/newColumnCount);
            widthOfNewColumn+=widthToSustract;

            if(column.IsLastColumn)
            {
                let usedSpace=this.RowItems[0].ColumnItems.reduce((previousValue, currentValue) => {return previousValue+currentValue.Options.Width},0)+widthOfNewColumn-column.Options.Width;
                this.SetColumnWidth(column,100-usedSpace);

            }else
                this.SetColumnWidth(column,column.Options.Width-widthToSustract);

        }
        return widthOfNewColumn;


    }

    public SetColumnWidth(column: ColumnItem, width: number) {
        let columnIndex=column.RowItem.ColumnItems.indexOf(column);
        if(columnIndex<0)
            return;

        for(let row of this.RowItems)
        {
            row.ColumnItems[columnIndex].SetWidth(width);
        }
    }
}